<script setup lang="ts">
type GingerProps = {
  isOutline: boolean
  styles: {
    top: string
    left: string
    transform: string
    position: 'absolute' | 'fixed'
  }
  color?: string
}

const props = defineProps<GingerProps>()

const getColor = (defaultColor: string) => {
  return props.color ? props.color : defaultColor
}
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 687.63 1241.3"
    :style="styles"
    class="-z-1 h-[25vh] w-[25vh] overflow-hidden"
  >
    <g id="a" />
    <g id="b" />
    <g id="c">
      <path
        class="u"
        :fill="getColor('#d4ae5a')"
        :fill-opacity="isOutline ? 0 : 1"
        :stroke-width="isOutline ? 10 : 0"
        stroke="#FFFFFF"
        d="M210.14,29.75c55.44-24.31,54.3,92.69,93.2,113.47,15.21,8.12,29.78,5.75,43.14,18.51,4.67,4.46,3.28,16.69,7.65,21.35,12.43,13.27,26.65,18.05,42.34,26.92,41.51,23.45,62.63,69.68,47.17,119.07-19.29,61.63-92.32,17.42-136.22,34.74-16.62,34.14,42.08,33.57,62.79,39.45,75.75,21.49,152.99,36.38,225.34,75.48,26.05,14.08,68.16,42.19,70.93,76.07,.69,8.42-13.35,10.96-13.12,20.24,.3,12.38,13.57,23.24,13.3,34.02-2.78,108.6-220-55.51-252.71-73.21-20.41-11.05-119.33-62.28-130.32-20.36-9.83,37.49,86.43,78.1,107.96,99.36,46.02,45.44,115.39,62.84,148.72,120.41,33.01,57.02,27.08,102.53-42.98,71.47-8.15,23.5,12.48,42,18.01,63.85,9.67,38.22,1.05,28.88-24.23,39.62-25.19,10.7-28.64-7.99-29.25,29.54-.6,36.96,32.58,63.02,38.18,98.91,8.6,55.1-31.78,99.96-68.53,135.38-49.18,47.38-93.31,66.8-159.77,29.31-19.62-11.07-45.32-34.76-50.89-58.05-9.3-38.94,26.15-59.13,44.82-86.59,34.27-50.39,14.54-105.92,11.84-161.95-.93-19.24-10.81-84.07-44.01-82.27-22.35,1.21-17.86,27-18.19,42.1-.72,32.73,1,37.45-13.5,67.46-17.96,37.17-18.5,101.55-68.66,105.82-84.72,7.22-108.91-98.33-94.08-159.66,15.87-65.6,78.66-90.45,97.85-152.99,9.56-31.16,29.15-133.46-21.09-143.66-33.12-6.72-44.76,36.44-77.13,5.23-40.77-39.31,6.84-53.26,23.65-81.83,17.94-30.49,17.97-69.76,52.63-93.56,13.45-9.24,46.16-7.44,56.15-18.6,15.2-16.97,1.66-52.76,.95-72.13-.72-19.32,3.22-33.94-8.91-47.1-14.55-15.79-41.15-6.52-52.06-30.88-18.39-41.05,33.23-71.84,45.99-104.71,11.89-30.63,1.52-54.63,25.72-82.81,13-15.14,32.91-34.05,27.32-17.4Z"
      />
    </g>
    <g id="d" />
    <g id="e" />
    <g id="f" />
    <g id="g" />
    <g id="h" />
    <g id="i" />
    <g id="j">
      <g id="k" />
      <g id="l" />
      <g id="m" />
      <g id="n" />
      <g id="o" />
      <g id="p" />
      <g id="q" />
      <g id="r" />
      <g id="s" />
      <g id="t" />
    </g>
  </svg>
</template>

<style scoped></style>
